export const API_HOST = process.env.REACT_APP_API_SERVER_ENDPOINT

export const lotDetailsServicePath = (id, postCode) => `/connect_api/owner_connect/${id}?zip=${postCode}`;
export const basicLotDetailsServicePath = (id) => `/connect_api/owner_connect/lot_validation/${id}`;
export const callMeServicePath = (id) => `/connect_api/owner_connect/${id}/help_requested`;
export const notMeServicePath = (id) => `/connect_api/owner_connect/${id}/wrong_user`;
export const submitFormServicePath = (id) => `/connect_api/owner_connect/${id}`;
export const GOOGLE_SUGGEST_ADDRESS_URL = "/cfrservices/call_for_release/geo-address";
export const DATE_FORMAT = "MM/DD/YYYY"

export const MAX_INPUT_LENGTH = 50;

export const MIN_ALLOWED_PICKUP_DAY = 0;
export const MAX_ALLOWED_PICKUP_DAY = 2;
export const GOOGLE_ANLYTICS_KEY = 'UA-150648948-1';




// WEBPACK FOOTER //
// ./src/config.js